import { Modals } from 'constants/modals'

export const ModalsInitialState = {
  [Modals.ACTION_CREATE_MODAL]: { isOpen: false },
  [Modals.ACTION_FULL_MODAL]: { isOpen: false },
  [Modals.ACTION_MINIMIZED_MODAL]: { isOpen: false },
  [Modals.ADD_LINK_FOR_ACTIVITY_MODAL]: { isOpen: false },
  [Modals.AI_CHAT_MODAL]: { isOpen: false },
  [Modals.AI_FIELD_VALUE_MODAL]: { isOpen: false },
  [Modals.AI_LINKED_FORMS_MODAL]: { isOpen: false },
  [Modals.AI_MATRIX_VALUE_MODAL]: { isOpen: false },
  [Modals.API_CLIENT_CREATE_MODAL]: { isOpen: false },
  [Modals.API_CLIENT_SECRET_MODAL]: { isOpen: false },
  [Modals.API_CLIENT_UPDATE_MODAL]: { isOpen: false },
  [Modals.AUTH_COMPANY_SELECT_MODAL]: { isOpen: false },
  [Modals.BUSINESS_ENTITY_MODAL]: { isOpen: false },
  [Modals.CHANGE_USER_PASSWORD_MODAL]: { isOpen: false },
  [Modals.CONFIRM_CHANGE_PARENT_PLAN_MODAL]: { isOpen: false },
  [Modals.CONFIRM_CHANGE_PLAN_TYPE_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_ACTION_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_ACTIVITY_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_CHAT_CONVERSATION_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_DASHBOARD_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_KPI_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_KPI_RESULT_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_MATRIX_ITEM_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_OBJECTIVE_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_PLAN_ITEM]: { isOpen: false },
  [Modals.CONFIRM_DELETE_REVIEW_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_RISK_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_RISK_TEMPLATE_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_RISK_VIEW_MODAL]: { isOpen: false },
  [Modals.CONFIRM_DELETE_SCHEDULED_REVIEW]: { isOpen: false },
  [Modals.CONFIRM_DELETE_WIDGET_MODAL]: { isOpen: false },
  [Modals.CONFIRM_EDIT_REVIEW_MODAL]: { isOpen: false },
  [Modals.CONFIRM_UNLINK_PLAN_ITEM_MODAL]: { isOpen: false },
  [Modals.DASHBOARD_SETTINGS_MODAL]: { isOpen: false },
  [Modals.DASHBOARD_WIDGET_SETTINGS_MODAL]: { isOpen: false },
  [Modals.EDIT_ACTIVITY_MODAL]: { isOpen: false },
  [Modals.EMAIL_PREVIEW_MODAL]: { isOpen: false },
  [Modals.GROUP_SECURITY_MODAL]: { isOpen: false },
  [Modals.IMAGE_CROPPER_MODAL]: { isOpen: false },
  [Modals.IMPORTED_RISK_MODAL]: { isOpen: false },
  [Modals.INJURY_MASTER_REVOKE_MODAL]: { isOpen: false },
  [Modals.INJURY_MASTER_SETTINGS_MODAL]: { isOpen: false },
  [Modals.KPI_CREATE_MODAL]: { isOpen: false },
  [Modals.KPI_FULL_MODAL]: { isOpen: false },
  [Modals.KPI_INTEGRATION_MODAL]: { isOpen: false },
  [Modals.KPI_MINIMIZED_MODAL]: { isOpen: false },
  [Modals.KPI_RECURRENCE_MODAL]: { isOpen: false },
  [Modals.KPI_RESULTS_MODAL]: { isOpen: false },
  [Modals.KPI_SCALE_MODAL]: { isOpen: false },
  [Modals.KPI_SET_RESULT_ROW_MODAL]: { isOpen: false },
  [Modals.LINKED_FORM_VIEW_MODAL]: { isOpen: false },
  [Modals.LINKING_SOURCE_DETAILS_MODAL]: { isOpen: false },
  [Modals.LOOKUP_FILTER_MODAL]: { isOpen: false },
  [Modals.NEW_USER_MODAL]: { isOpen: false },
  [Modals.OBJECTIVE_FULL_MODAL]: { isOpen: false },
  [Modals.OBJECTIVE_MINIMIZED_MODAL]: { isOpen: false },
  [Modals.OBJECT_SECURITY_MODAL]: { isOpen: false },
  [Modals.PICKLIST_OPTION_MODAL]: { isOpen: false },
  [Modals.PLAN_ACTIVITIES_MODAL]: { isOpen: false },
  [Modals.PLAN_CLONE_MODAL]: { isOpen: false },
  [Modals.PLAN_FILTER_MODAL]: { isOpen: false },
  [Modals.PLAN_ITEM_PREVIEW_MODAL]: { isOpen: false },
  [Modals.PLAN_CREATE_MODAL]: { isOpen: false },
  [Modals.PLAN_OBJECTIVES_LIST_MODAL]: { isOpen: false },
  [Modals.PLAN_SCHEDULE_DEFAULTS_MODAL]: { isOpen: false },
  [Modals.PLAN_COLUMNS_SETTINGS_MODAL]: { isOpen: false },
  [Modals.PLAN_TYPE_CREATE_MODAL]: { isOpen: false },
  [Modals.PROPERTY_DETAILS_MODAL]: { isOpen: false },
  [Modals.REPORT_PERMISSIONS_MODAL]: { isOpen: false },
  [Modals.REPORT_UPDATE_MODAL]: { isOpen: false },
  [Modals.RESOURCE_CREATE_MODAL]: { isOpen: false },
  [Modals.RESPONSE_TYPES_SET_MODAL]: { isOpen: false },
  [Modals.REVIEW_CREATE_MODAL]: { isOpen: false },
  [Modals.REVIEW_DETAILS_MODAL]: { isOpen: false },
  [Modals.RISK_CONFIRM_MODAL]: { isOpen: false },
  [Modals.RISK_EDIT_PREFIX_MODAL]: { isOpen: false },
  [Modals.RISK_FIELD_HISTORY_MODAL]: { isOpen: false },
  [Modals.RISK_FIELD_RECURRENCE_MODAL]: { isOpen: false },
  [Modals.RISK_MANDATORY_CHECK_MODAL]: { isOpen: false },
  [Modals.RISK_MATRIX_APPETITE_CONF_MODAL]: { isOpen: false },
  [Modals.RISK_MATRIX_APPETITE_OPTIONS_MODAL]: { isOpen: false },
  [Modals.RISK_MATRIX_MODAL]: { isOpen: false },
  [Modals.RISK_MATRIX_OPTIONS_MODAL]: { isOpen: false },
  [Modals.RISK_RECURRENCE_MODAL]: { isOpen: false },
  [Modals.RISK_TEMPLATE_ADD_FORM_MODAL]: { isOpen: false },
  [Modals.RISK_TEMPLATE_SETTINGS_MODAL]: { isOpen: false },
  [Modals.RISK_TEMPLATE_SYSTEM_PROCESSES_MODAL]: { isOpen: false },
  [Modals.RISK_VIEW_ADD_FILTER_MODAL]: { isOpen: false },
  [Modals.RISK_VIEW_CREATE_MODAL]: { isOpen: false },
  [Modals.RISK_VIEW_FILTER_MODAL]: { isOpen: false },
  [Modals.SCALE_OPTION_CREATE_MODAL]: { isOpen: false },
  [Modals.SCALE_OPTION_EDIT_MODAL]: { isOpen: false },
  [Modals.SCHEDULED_RISK_RECURRENCE_MODAL]: { isOpen: false },
  [Modals.SCHEDULE_REVIEW_MODAL]: { isOpen: false },
  [Modals.SECURITY_PROFILE_MODAL]: { isOpen: false },
  [Modals.SESSION_EXPIRING_MODAL]: { isOpen: false },
  [Modals.SELECT_MULTI_VALUE_MODAL]: { isOpen: false },
  [Modals.SET_COLOR_MODAL]: { isOpen: false },
  [Modals.SET_DAY_WORKING_HOURS_MODAL]: { isOpen: false },
  [Modals.SET_DOCUMENT_DESCRIPTION_MODAL]: { isOpen: false },
  [Modals.SET_LICENCING_MODAL]: { isOpen: false },
  [Modals.SIDEBAR_REVIEW_DETAILS_MODAL]: { isOpen: false },
  [Modals.SUB_PLAN_CREATE_MODAL]: { isOpen: false },
  [Modals.SYNC_RULES_MODAL]: { isOpen: false },
  [Modals.SYSTEM_PROCESS_CREATE_MODAL]: { isOpen: false },
  [Modals.TEXT_FIELD_CONTENT]: { isOpen: false },
  [Modals.TWO_FACTOR_ADMIN_RESET_MODAL]: { isOpen: false },
  [Modals.TWO_FACTOR_DISABLE_MODAL]: { isOpen: false },
  [Modals.TWO_FACTOR_REGENERATE_CODES_MODAL]: { isOpen: false },
  [Modals.TWO_FACTOR_SETUP_MODAL]: { isOpen: false }
}
